import Card from '../payment/card';
import User from '../user/user';
import PayerIdentification from './payer-identification';
export default class Payer {
  public email?: string;
  public identification?: PayerIdentification;

  constructor(user: User, card: Card) {
    this.email = user?.email;
    this.identification = new PayerIdentification(card);
  }
}
